import { render } from "./fundEdit.vue?vue&type=template&id=134bd42b&scoped=true"
import script from "./fundEdit.vue?vue&type=script&lang=js"
export * from "./fundEdit.vue?vue&type=script&lang=js"

import "./fundEdit.vue?vue&type=style&index=0&id=134bd42b&lang=less&scoped=true"

import exportComponent from "/var/www/html/pro-cms-dtinsights/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134bd42b"]])

export default __exports__